import {OrganizationLevel, PermissionDefinitionDto} from "@/api/appService";
import {ActionContext} from "vuex";
import {createNgTree, INgNode} from "@/utils/tree";

export interface PermissionState {
  menus: IPermissionItem[]
}

export interface IPermissionItem {
  displayOrder: number;
  name: string;
  displayName: string;
  children?: IPermissionItem[];
  icon?: string;
  url?: string;
  id: number
}

const cache = JSON.parse(window.localStorage.getItem('permission') || '{}') as PermissionState



export default {
  namespaced: true,
  state: () => ({
    ...{
      menus:[]
    },
    ...cache
  } as PermissionState),
  mutations: {
    SET_MENUS(state: PermissionState, menus: IPermissionItem[]) {
      state.menus = menus
      window.localStorage.setItem('permission',JSON.stringify({...state,menus:menus}))
    }
  },
  actions: {
    generateMenus(context: ActionContext<PermissionState, any>, input: { permissions: string[], roles: string[], level: string, permissionDefinitions: PermissionDefinitionDto[] }): Promise<any> {
      return new Promise<any>((resolve) => {
        console.log('permission/generateMenus in call')
        if (!input.permissions) {
          context.commit('SET_MENUS', [])
        } else {
          let accessedMenus;
          const permissionTree = createNgTree<PermissionDefinitionDto>(
            input.permissionDefinitions,
            'parentId',
            'id',
            null,
            'children',
            '',
            false,
            'id'
          )

          let organizationLevel: OrganizationLevel;
          switch (input.level) {
            case '总部':
              organizationLevel = OrganizationLevel.Headquarters;
              break;
            case '大区':
              organizationLevel = OrganizationLevel.BigArea;
              break;
            case '片区':
              organizationLevel = OrganizationLevel.PartialArea;
              break;
            case '门店':
              organizationLevel = OrganizationLevel.Store;
              break;

          }

          accessedMenus = filterPermission(input.permissions!, permissionTree, organizationLevel!);
          context.commit('SET_MENUS', accessedMenus)
          resolve();
        }
      })

    }
  },
  getters: {
    menus(state: PermissionState): IPermissionItem[] {
      return state.menus ?? [];
    }
  }
}


function filterPermission(permissions: string[], permissionDefinitions: INgNode<PermissionDefinitionDto>[], level: OrganizationLevel) {
  let res: IPermissionItem[] = [];
  permissionDefinitions.forEach(definition => {
    if (!(definition.data.levels?.some(s => s === level) ?? false)) {
      // don't do anything
      return
    }
    let permissionItem: IPermissionItem | undefined;
    if (permissions.some(name => name === definition.data.name)) {
      permissionItem = {
        id: definition.id!,
        name: definition.data.name!,
        displayName: definition.data.displayName!,
        displayOrder: 0,
        icon: definition.data.icon,
        children: [],
        url: definition.data.url
      };
      let children = definition.children;
      if (children && children.length) {
        permissionItem.children = filterPermission(permissions, children, level);
      }
    }

    if (permissionItem) {
      res.push(permissionItem);
    }


  });

  return res;
}
